module.exports = {
    'selectLanguage': 'Selecione o seu idioma'
};